(function () {
  'use strict';

  const HIDDEN_CLASS = 'hidden';
  const ROOT_SELECTOR = '.content-richtext';
  const EXCERPT_SELECTOR = '.content-richtext__content--excerpt';
  const FULL_SELECTOR = '.content-richtext__content--full-description';
  const READ_MORE_BTN_SELECTOR = '.content-richtext__content__toggle-button--read-more';
  const READ_LESS_BTN_SELECTOR = '.content-richtext__content__toggle-button--read-less';

  class ReadMoreToggle {
    static instanceCounter = 0;

    constructor(rootElement) {
      this.root = rootElement;
      this.excerpt = this.root.querySelector(EXCERPT_SELECTOR);
      this.full = this.root.querySelector(FULL_SELECTOR);
      this.readMoreBtn = this.root.querySelector(READ_MORE_BTN_SELECTOR);
      this.readLessBtn = this.root.querySelector(READ_LESS_BTN_SELECTOR);

      if (!this.excerpt || !this.full || !this.readMoreBtn || !this.readLessBtn) {
        return;
      }


      const idSuffix = ++ReadMoreToggle.instanceCounter;
      if (!this.excerpt.id) this.excerpt.id = `rmt-excerpt-${idSuffix}`;
      if (!this.full.id) this.full.id = `rmt-full-${idSuffix}`;

      this.readMoreBtn.setAttribute('aria-controls', this.full.id);
      this.readLessBtn.setAttribute('aria-controls', this.excerpt.id);

      this._initializeVisibilityAndAria();
      this._bindEvents();
    }

    _bindEvents() {
      this.readMoreBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.expand();
      });

      this.readLessBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.collapse();
      });
    }

    _initializeVisibilityAndAria() {
      const excerptHidden = this.excerpt.classList.contains(HIDDEN_CLASS);
      const fullHidden = this.full.classList.contains(HIDDEN_CLASS);

      const shouldStartCollapsed = (excerptHidden && fullHidden) || (!excerptHidden && !fullHidden)
        ? true
        : (!excerptHidden && fullHidden);

      if (shouldStartCollapsed) {
        this._setRegionVisibility(this.excerpt, true);
        this._setRegionVisibility(this.full, false);
        this._setButtonVisibility(this.readMoreBtn, true);
        this._setButtonVisibility(this.readLessBtn, false);
        this.readMoreBtn.setAttribute('aria-expanded', 'false');
      } else {
        this._setRegionVisibility(this.excerpt, false);
        this._setRegionVisibility(this.full, true);
        this._setButtonVisibility(this.readMoreBtn, false);
        this._setButtonVisibility(this.readLessBtn, true);
        this.readMoreBtn.setAttribute('aria-expanded', 'true');
      }
    }

    expand() {
      this._setRegionVisibility(this.excerpt, false);
      this._setRegionVisibility(this.full, true);
      this._setButtonVisibility(this.readMoreBtn, false);
      this._setButtonVisibility(this.readLessBtn, true);
      this.readMoreBtn.setAttribute('aria-expanded', 'true');
      // Keep keyboard focus on the active control
      if (this.readLessBtn && !this.readLessBtn.classList.contains('hidden')) {
        this.readLessBtn.focus();
      }
    }

    collapse() {
      this._setRegionVisibility(this.excerpt, true);
      this._setRegionVisibility(this.full, false);
      this._setButtonVisibility(this.readMoreBtn, true);
      this._setButtonVisibility(this.readLessBtn, false);
      this.readMoreBtn.setAttribute('aria-expanded', 'false');
      // Keep keyboard focus on the active control
      if (this.readMoreBtn && !this.readMoreBtn.classList.contains('hidden')) {
        this.readMoreBtn.focus();
      }
    }

    _setRegionVisibility(regionEl, isVisible) {
      if (isVisible) {
        regionEl.classList.remove(HIDDEN_CLASS);
        regionEl.setAttribute('aria-hidden', 'false');
      } else {
        regionEl.classList.add(HIDDEN_CLASS);
        regionEl.setAttribute('aria-hidden', 'true');
      }
    }

    _setButtonVisibility(buttonEl, isVisible) {
      if (isVisible) {
        buttonEl.classList.remove(HIDDEN_CLASS);
      } else {
        buttonEl.classList.add(HIDDEN_CLASS);
      }
    }

    static initAll(root = document) {
      const nodes = root.querySelectorAll(ROOT_SELECTOR);
      nodes.forEach((node) => new ReadMoreToggle(node));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ReadMoreToggle.initAll());
  } else {
    ReadMoreToggle.initAll();
  }

  window.ReadMoreToggle = ReadMoreToggle;
})();
